import axios from 'axios'
import { extractError } from '../utils/errorHandler'

export const newCancelSource = () => axios.CancelToken.source()
export const isCancel = (err) => axios.isCancel(err)

/**
 * Busca da barra do topo: ordens (código ou lote da OP), itens e lotes (estes só para quem vê o estoque).
 * cancelToken: de newCancelSource(), para cancelar quando a pessoa continua digitando.
 */
export const search = async (q, take = 5, cancelToken) => {
  try {
    const { data } = await axios.get('search', { params: { q, take }, cancelToken })
    return data
  } catch (err) {
    if (axios.isCancel(err)) throw err
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
